import Cookies from "js-cookie";
import { LOCAL_BASE_URL } from "../constants/constants";
import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

export const register = async (username, email, password) => {
	try {
		const response = await axiosRequestInterceptor.post(`/users/register`, {
			username: username,
			email: email,
			password: password,
		});
		//logger.log("Response for register", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};

export const verifyEmail = async (email, OTP) => {
	try {
		logger.log("email", email, "OTP", OTP);
		const response = await axiosRequestInterceptor.post(`/users/verifyOTP`, {
			email: email,
			otp: OTP,
		});
		logger.log("response", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};

export const resend = async (email) => {
	try {
		logger.log("email", email);
		const response = await axiosRequestInterceptor.post(`/users/resendOTP`, {
			email: email,
		});
		logger.log("response", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};

export const addPersonalDetails = async (
	email,
	firstName,
	lastName,
	phoneNumber,
	city,
	state,
	country,
	exam,
	stripeCustomerId
) => {
	try {
		logger.log("email", email, "firstName", firstName, "lastName", lastName, "phoneNumber", phoneNumber, "city", city, "state", state, "country", country, "exam", exam, "stripeCustomerId", stripeCustomerId);
		const userId = Cookies.get("userId");
		logger.log("User ID from cookies:", userId);
		const response = await axiosRequestInterceptor.post(`/users/addPersonalDetails`, {
			email: email,
			firstName: firstName,
			lastName: lastName,
			phoneNo: phoneNumber,
			city: city,
			state: state,
			country: country,
			exam: exam,
			userId: userId,
			stripeCustomerId: stripeCustomerId,
		});
		logger.log("response", response);
		return { success: true, data: response.data };
	} catch (error) {
		logger.log("error", error);
		return { success: false, error: error.response.data.error };
	}
};
